// News content. All facts drawn from the user's source direction —
// no fabricated events, quotes, or claims.
export const NEWS = [
  {
    slug: "erap-healing-growth-community",
    title: "Healing, Growth & Community — S.C.C.F. / E.R.A.P.",
    date: "2026-08-17",
    location: "Philadelphia, PA",
    excerpt:
      "Freeway sits with the men of S.C.C.F. through the E.R.A.P. Program — a conversation on opening up, perseverance, and refusing to let the present define the future.",
    hero: "/assets/news/erap-healing/news-erap-healing-01.jpg",
    images: [
      "/assets/news/erap-healing/news-erap-healing-01.jpg",
      "/assets/news/erap-healing/news-erap-healing-02.jpg",
    ],
    body: [
      "Philadelphia — Freeway spent an afternoon at S.C.C.F., stepping inside the E.R.A.P. (Exodus Recovery Alumni Program) — a military-structured residential space that supports men working through healing and growth.",
      "The room filled with residents in EXODUS ALUMNI tees. Freeway kept it plain and personal: opening up when it's the last thing you want to do, staying disciplined through the hard days, and moving with purpose when the noise is loud.",
      "He was joined by partners from Urban Trauma Recovery Center and ACASIA — organizations doing the day-to-day work of restoration in Philadelphia.",
      "\"Where you are right now doesn't have to be where you finish.\" That was the tone of the visit — grounded, respectful, and about the work that lives beyond the stage.",
    ],
    tags: ["community", "philadelphia"],
  },
  {
    slug: "philadelphia-union-philly-kit",
    title: "Philadelphia Union — The Philly Kit",
    date: "2026-08-12",
    location: "Fitler Club · Philadelphia",
    excerpt:
      "An invite-only Philadelphia Union celebration at the Fitler Club marked the drop of the new Philly Kit — and Freeway was one of the first to wear it, headlining the night with an intimate performance.",
    hero: "/assets/news/philadelphia-union/news-philadelphia-union-01.jpg",
    images: [
      "/assets/news/philadelphia-union/news-philadelphia-union-01.jpg",
      "/assets/news/philadelphia-union/news-philadelphia-union-02.jpg",
      "/assets/news/philadelphia-union/news-philadelphia-union-03.jpg",
    ],
    body: [
      "The Philadelphia Union unveiled its new Philly Kit at an invite-only celebration inside the Fitler Club, and Freeway took the mic for a short, intimate set in front of the club and its guests.",
      "The kit — designed with adidas and stamped with the PHILLY skyline wordmark, snake crest and rainbow trim — nods squarely to the city. Freeway wore it under the lights before it hit the public, one of the first to represent the drop.",
      "It's a natural link-up: a Philly club, a Philly artist twenty-three years in, and a jersey built to look like the city sounds. The night was closed-doors, but the pictures tell it clean.",
    ],
    tags: ["appearance", "philadelphia"],
  },
  {
    slug: "abc-action-news-philly-freefest",
    title: "6abc Action News × Philly FreeFest",
    date: "2026-08-07",
    location: "6abc Studios · Philadelphia",
    excerpt:
      "Freeway visited 6abc Action News for a feature on the third annual Philly FreeFest — time on the anchor desk with Rick and Sharrie Williams, plus a behind-the-scenes look at the newsroom.",
    hero: "/assets/news/abc6-freefest/news-abc6-freefest-01.jpg",
    heroPosition: "50% 30%",
    heroAspect: "aspect-[4/5]",
    images: [
      "/assets/news/abc6-freefest/news-abc6-freefest-01.jpg",
      "/assets/news/abc6-freefest/news-abc6-freefest-02.jpg",
      "/assets/news/abc6-freefest/news-abc6-freefest-03.jpg",
    ],
    body: [
      "Ahead of the third annual Philly FreeFest, 6abc Action News hosted Freeway for a feature on the festival — the artists, the community programs, and how it grew from a one-day show into a city moment.",
      "Freeway stopped by the anchor desk with Rick and Sharrie Williams, then walked the WPVI 1996 history-timeline wall — a fitting backdrop for a Philly story that spans decades.",
      "Cameras followed a sit-down interview in the lobby, iced chains and black FTA snapback in frame — the same look Philly has seen on stage all summer.",
    ],
    tags: ["press", "freefest"],
  },
  {
    slug: "freefest-2026-recap",
    title: "FreeFest 2026 · The Recap",
    date: "2026-08-01",
    location: "Marine Parade Grounds · Philadelphia",
    excerpt:
      "Twenty-three years of Philadelphia Freeway — a full-album performance with a live band, appearances by Beanie Sigel, M.O.P. and Smif-N-Wessun, and the exclusive Paper Planes × FTA anniversary drop making its physical debut.",
    hero: "/assets/news/freefest-2026/news-freefest-2026-02.jpg",
    images: [
      "/assets/news/freefest-2026/news-freefest-2026-01.jpg",
      "/assets/news/freefest-2026/news-freefest-2026-02.jpg",
      "/assets/news/freefest-2026/news-freefest-2026-03.jpg",
      "/assets/news/freefest-2026/news-freefest-2026-04.jpg",
    ],
    body: [
      "FreeFest 2026 celebrated twenty-three years of Philadelphia Freeway's debut album with a full-album performance backed by a live band — front to back, no skips.",
      "Special appearances came from Beanie Sigel, M.O.P. and Smif-N-Wessun. A room full of the voices that helped shape the record and the era it lived in.",
      "Paper Planes collaborated with FTA (Freedom Thinkers Academy) on an exclusive twenty-three-year anniversary capsule, released for the first time on-site at the Marine Parade Grounds — the anniversary snapback and the Snatch the Dishes tee sold in-person before the online drop.",
      "Beyond the music, the day carried the community piece FreeFest has become known for: free health screenings, resource tables and family programming across the grounds — turning the festival into a full-day city experience.",
    ],
    tags: ["freefest", "collection"],
  },
  {
    slug: "sneak-peek-fta-x-planes",
    title: "FTA × Paper Planes — 23 Years of Philadelphia Freeway",
    date: "2026-08-01",
    location: "FreeFest · Philadelphia",
    excerpt:
      "The story behind the anniversary collaboration between FTA (Freedom Thinkers Academy) and Paper Planes. The first drop landed physically at FreeFest — online sales open this fall, with additional pop-ups planned through the year.",
    hero: "/assets/categories/planes-fta/category-planes-fta-06.jpg",
    images: [
      "/assets/categories/planes-fta/category-planes-fta-06.jpg",
      "/assets/categories/planes-fta/category-planes-fta-07.jpg",
      "/assets/categories/planes-fta/category-planes-fta-01.jpg",
    ],
    body: [
      "FTA × Paper Planes marks twenty-three years of Philadelphia Freeway with a capsule that lives at the intersection of the record and the streets that raised it.",
      "The set: the anniversary 9Fifty Snapback Crown, the Tracklist Tee (front-and-back roll call of the album), and the Snatch the Dishes Anniversary Tee — each piece stitched with details that read like a Philly footnote to the 2003 debut.",
      "First drop landed physically at FreeFest — hand-to-hand at the Marine Parade Grounds. Starting this fall the collection moves online, and additional pop-up dates are planned throughout the year for cities that shaped the sound.",
      "This is a partnership, not a merch table. FTA (Freedom Thinkers Academy) brings the community lineage, Paper Planes brings the design language, and the album brings the reason.",
    ],
    tags: ["collection", "collaboration"],
  },
];

// Newest-first ordering
export const newsSorted = () => [...NEWS].sort((a, b) => (a.date < b.date ? 1 : -1));
export const getNews = (slug) => NEWS.find((n) => n.slug === slug);
